import {
  FormControl,
  InputLabel,
  LinearProgress,
  ListItemIcon,
  MenuItem,
  Select,
} from '@material-ui/core';
import TimelineIcon from '@mui/icons-material/Timeline';
import React from 'react';
import { useTranslation } from 'react-i18next';

export function ObjectiveSelect({
  objetivos,
  objetivoId,
  setObjetivoId,
  isLoading,
}) {
  const { t } = useTranslation()
  return (
    <React.Fragment>
      <FormControl fullWidth size="small" variant="outlined">
        <InputLabel id="select-objective-label">{t('objective-select.label')}</InputLabel>
        <Select
          labelId="select-objective-label"
          id="select-objective"
          value={objetivoId}
          label={t('objective-select.label')}
          onChange={(event) => {
            setObjetivoId(event.target.value);
          }}
          variant="outlined"
          style={{ display: 'flex', backgroundColor: 'white' }}
          className="select__input-hiden-icon"
          disabled={isLoading}
          MenuProps={{ disableScrollLock: true }}
        >
          <MenuItem value="">
            <em>Seleccione un objetivo</em>
          </MenuItem>
          {objetivos.map((item) => (
            <MenuItem key={item.objetivo_id} value={item.objetivo_id}>
              <ListItemIcon>
                <TimelineIcon style={{ color: item.color }} />
              </ListItemIcon>
              {item.nombre}
            </MenuItem>
          ))}
        </Select>
        {isLoading && <LinearProgress style={{ marginTop: 5 }} />}
      </FormControl>
    </React.Fragment>
  );
}
